import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Button, Text } from "@sundae/ui-toolkit";
import { useRewardAssetMetadata } from "../../hooks/useRewardAssetMetadata.js";
import { useAppContext } from "../../stores/index.js";
import { getAssetName } from "../../utils/assets.utils.js";
import LoadingComponent from "../LoadingComponent/LoadingComponent.js";
const NoRewards = () => {
    const { t, currentLocale } = useI18N("rewards");
    const { state: { clientSettings: { externalRoutes, clientTranslations }, }, } = useAppContext();
    const { data: [rewardAssetMetadata], isLoading, } = useRewardAssetMetadata();
    if (isLoading) {
        return _jsx(LoadingComponent, {});
    }
    return (_jsxs("div", { className: "grid place-items-center gap-4", children: [_jsx(Text, { tag: "div", children: t("noRewardsMessage", {
                    asset: getAssetName(rewardAssetMetadata),
                }) }), _jsx(Text, { tag: "div", children: t("toEarnRewards", {
                    asset: getAssetName(rewardAssetMetadata),
                    brand: clientTranslations[currentLocale].protocol.title,
                }) }), _jsx(Button, { variant: "gradient", onClick: () => window.open(externalRoutes.protocol, "_blank"), children: clientTranslations[currentLocale].paths.protocol })] }));
};
export default NoRewards;
//# sourceMappingURL=NoRewards.js.map